import { render, staticRenderFns } from "./Measure.vue?vue&type=template&id=22f6988e"
import script from "./Measure.vue?vue&type=script&lang=js"
export * from "./Measure.vue?vue&type=script&lang=js"
import style0 from "./Measure.vue?vue&type=style&index=0&id=22f6988e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports